import { SET_GRID_VIEW, CLEAR_GRID_VIEW } from "./type";

// set grid view state
export const setGridView = (isSmallGrid) => ({
  type: SET_GRID_VIEW,
  payload: isSmallGrid
});

// clear grid view state
export const clearGridView = () => ({
  type: CLEAR_GRID_VIEW
});
